import React from "react";
import { Fade } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { DIALOG_ANIMATIONS } from "../utils/constants";

const FadeTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Fade
      ref={ref}
      {...props}
      timeout={{
        enter: DIALOG_ANIMATIONS.ENTER_DURATION,
        exit: DIALOG_ANIMATIONS.EXIT_DURATION
      }}
    />
  );
});

export default FadeTransition;
